import * as React from 'react';
import { createContext, useContext } from 'react';
import { connectStateResults } from 'react-instantsearch-core';
import { mapProductProjectionToListingProduct } from '@grandvisionhq/products';
import { useIntl } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';

const AlgoliaDataContext = /*#__PURE__*/ createContext(null);
AlgoliaDataContext.displayName = 'AlgoliaDataContext';
function useAlgoliaData() {
    const context = useContext(AlgoliaDataContext);
    if (context === null) {
        throw new Error('No AlgoliaDataContext available.');
    }
    return context;
}
const isProductProjection = (data)=>'masterVariant' in data && 'slug' in data
;
function AlgoliaDataProvider({ children , searchState , searchResults , allSearchResults  }) {
    var ref, ref1, ref2;
    const intl = useIntl();
    if (!searchState || !searchResults || !allSearchResults) return null;
    const results = searchResults.hits;
    const mappedResults = React.useMemo(()=>results.map((hit)=>isProductProjection(hit) ? mapProductProjectionToListingProduct(hit, intl) : undefined
        ).filter(isDefined)
    , [
        results,
        intl
    ]);
    const value = {
        mappedResults,
        searchState,
        allSearchResults,
        total: searchResults.nbHits,
        searchQuery: searchResults === null || searchResults === void 0 ? void 0 : searchResults.query,
        facetOrder: searchResults === null || searchResults === void 0 ? void 0 : (ref = searchResults.renderingContent) === null || ref === void 0 ? void 0 : (ref1 = ref.facetOrdering) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.facets) === null || ref2 === void 0 ? void 0 : ref2.order
    };
    return /*#__PURE__*/ React.createElement(AlgoliaDataContext.Provider, {
        value: value
    }, children);
}
var AlgoliaDataProvider$1 = connectStateResults(AlgoliaDataProvider);

export { AlgoliaDataProvider, AlgoliaDataProvider$1 as default, useAlgoliaData };
//# sourceMappingURL=AlgoliaDataProvider.js.map
